/**
 * Created by du on 16/11/23.
 */
// let usedData = [];
let timeCount = 0;
let oldDataArray = [];

export default class {
	constructor(canvas, stream, {style, timeLimit}) {
		this.canvas = canvas;
		this.stream = stream;
		this.audioCtx = null;
		this.canvasCtx = null;
		this.sourceNode = null;
		this.analyserNode = null;
		this.dataArray = null;
		this.timer = null;
		this.style = style || 'sumWare';
		this.isLoop = !!!timeLimit;
		this.timeLimit = timeLimit || 60
		this.setup();
	}

	setup() {
		this.audioCtx = new window.AudioContext();
		this.canvasCtx = this.canvas.getContext('2d');
		this.sourceNode = this.audioCtx.createMediaStreamSource(this.stream);
		this.analyserNode = this.audioCtx.createAnalyser();
		this.analyserNode.fftSize = 512;
		this.dataArray = new Uint8Array(this.analyserNode.frequencyBinCount);
		this.analyserNode.getByteFrequencyData(this.dataArray);
		this.sourceNode.connect(this.analyserNode);

		this.clear();
	}

	clear() {
		this.canvasCtx.fillStyle = '#F2F6FB';
		this.canvasCtx.fillRect(0, 0, this.canvas.width, this.canvas.height);
		if (this.isLoop) {
			this.drawLine(this.canvasCtx, 'red', 0, this.canvas.height/2, this.canvas.width, this.canvas.height/2)();
		}
	}

	draw() {
		timeCount ++;
		this.analyserNode.getByteTimeDomainData(this.dataArray);
		let height = this.canvas.height;
		let width = this.canvas.width;
		let meterWidth = 2;
		let gap = 0.1;
		let meterNum = this.canvas.width / (meterWidth + gap);
		let step = Math.round(this.dataArray.length / meterNum); //频谱分析采样步长

		let waveType = this.style;
		let timeLimit = this.timeLimit;
		switch (waveType) {
			case 'middle':
					for (let i = 0; i < meterNum; i++) {
						let value = this.dataArray[i * step];
						let isDraw = true;
						if (!oldDataArray[i*step]){
							oldDataArray[i*step] = value;
						}else {
							let oldValue = oldDataArray[i * step];
							isDraw = Math.abs(value-oldValue) > 2;
						}
						if (isDraw){
							oldDataArray[i*step] = value;
							value = value > 128 ? (value - 128) : 0;
							let y = height / 2 - value;
							this.canvasCtx.fillRect(i * 7, y, meterWidth, -value * 3);
							this.canvasCtx.fillRect(i * 7, y, meterWidth, value * 1.5);
							this.canvasCtx.fillStyle = '#3399ff';
						}
					}
				// }
				break;
			case 'bottom':
				this.timer = window.requestAnimationFrame(this.draw.bind(this));
				this.clear();
				for (let i = 0; i < meterNum; i++) {
					let value = this.dataArray[i * step];
					let isDraw = true;
					if (!oldDataArray[i*step]){
						oldDataArray[i*step] = value;
					}else {
						let oldValue = oldDataArray[i * step];
						isDraw = Math.abs(value-oldValue) > 2;
					}
					if (isDraw){
						oldDataArray[i*step] = value;
						value = value > 128 ? (128 - value) * 10 : 0;
						this.canvasCtx.fillRect(i * 7, height, meterWidth, value);
						this.canvasCtx.fillStyle = '#3399ff';
					}
				}
				break;
			case 'siriWave':

				break;
			case 'sumWare':
				let timeInterval = 100;
				step = width/(timeLimit*1000/timeInterval);
				this.drawLine(this.canvasCtx, '#3399ff', 0, 0, 0, 0, step, timeCount)();
				if (!this.timeIntervalCtl) {
					this.timeIntervalCtl = setInterval(this.draw.bind(this), timeInterval);
				}
				// setTimeout(this.draw.bind(this), timeInterval);
				if (this.isLoop && (this.timeLimit * 1000 === timeCount * timeInterval)){
					this.clear();
					timeCount = 0;
				}
				break;
			default:
				break;
		}
	}

	drawLine(canvasCtx, color, movex, movey, linex, liney, step, timeCount){
		let averageEnergy;
		let totalEnergy = 0;
		this.dataArray.map(function(d){
			totalEnergy += d;
		})
		averageEnergy = totalEnergy/this.dataArray.length;
		let left = (128 === averageEnergy ? 0 : 128 - averageEnergy) * 200;
		if (Math.abs(left) > 250) left = 250;
		return function (){
			if (step){
				timeCount ++;
				linex = movex = (timeCount -1)*step;
				movey = 300 - left;
				liney = 300 + left;
	      // movey = 300 - Math.floor(Math.random() * 200)
				// liney = 300 + Math.floor(Math.random() * 200)
			}
		  canvasCtx.strokeStyle = color;
			canvasCtx.beginPath();
			canvasCtx.moveTo(movex, movey);
			canvasCtx.lineTo(linex, liney);
			canvasCtx.stroke();
		}
	}

	play() {
		let {width, height} = this.canvas;
		if (this.style === 'sumWare'){
			this.drawLine(this.canvasCtx, 'red', 0, height/2, width, height/2)();
			this.draw();
		}else {
			this.draw();
		}
	}

	stop() {
		if (this.timer) window.cancelAnimationFrame(this.timer);
		if (this.timeIntervalCtl) window.clearInterval(this.timeIntervalCtl);
		this.clear();
		timeCount = 0;
	}

	destroy() {
		this.stop();
		this.canvas = null;
		this.stream = null;
		this.audioCtx = null;
		this.canvasCtx = null;
		this.sourceNode = null;
		this.analyserNode = null;
		this.dataArray = null;
	}
}



/** WEBPACK FOOTER **
 ** ./src/components/Common/Recorder/visualizer.js
 **/